module.exports = __webpack_public_path__ + "static/media/14UNEP13.b3ec8ddf.jpg";